import React from 'react';
import { View, Text, Platform } from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { useTheme } from '../../../../theme/useTheme';

const LocationRequiredMessage: React.FC = () => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === 'dark' && Platform.OS !== 'web';

  return (
    <View style={{ padding: 16, alignItems: 'center', justifyContent: 'center' }}>
      <MaterialIcons
        name="place"
        size={32}
        color={isDark ? colors.brand.primary : '#0066CC'}
        style={{ marginBottom: 8 }}
      />
      <Text
        style={{
          fontSize: 16,
          color: isDark ? colors.brand.primary : '#0066CC',
          fontWeight: '500',
          marginBottom: 8,
        }}
      >
        Location Required
      </Text>
      <Text style={{ fontSize: 14, color: isDark ? colors.text.secondary : '#555', textAlign: 'center' }}>
        Please select a location in the header to view and filter employees.
      </Text>
    </View>
  );
};

export default LocationRequiredMessage;
